module.exports = __webpack_public_path__ + "img/block_5.c79845a6.webp";